export default __webpack_public_path__ + "static/media/Simple (2).cc1984f3.png";